import { render, staticRenderFns } from "./social-security.vue?vue&type=template&id=229ea3f2&"
import script from "./social-security.vue?vue&type=script&lang=js&"
export * from "./social-security.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports